<template>
  <div>
    <MessageList
      :messages="messages"
      :approvals="approvals"
      :loading-message="loadingMessage"
    />
    <MessageCompose @compose="sendMessage" :sending-message="sendingMessage" />
  </div>
</template>
<script>
import MessageList from "./MessageComponent/MessageList.vue"
import MessageCompose from "./MessageComponent/MessageCompose.vue"

export default {
  props: ["messages", "approvals", "loadingMessage", "sendingMessage"],

  components: { MessageList, MessageCompose },

  methods: {
    sendMessage(message, attachments) {
      this.$emit("compose", message, attachments)
    }
  }
}
</script>
